import { render } from "./BaseForm.vue?vue&type=template&id=3faf6d6e&scoped=true&bindings={\"isOpen\":\"props\",\"initialValues\":\"props\",\"inEditMode\":\"setup\",\"handleDidDismiss\":\"setup\",\"formInfo\":\"setup\"}"
import script from "./BaseForm.vue?vue&type=script&lang=js"
export * from "./BaseForm.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-3faf6d6e"

export default script